import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class GalleryArrowLeft extends React.Component {
  static propTypes = {
    currentSlide: PropTypes.number,
    previousSlide: PropTypes.func,
  }

  render() {
    const { currentSlide, previousSlide } = this.props;
    const styles = {
      wrapper: classnames({
        'gallery--arrow': true,
        'gallery--arrow-left': true,
        'gallery--arrow--disabled': currentSlide === 0,
      }),
    };

    return (
      <div className={styles.wrapper} onClick={previousSlide} />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Gallery/GalleryArrowLeft.jsx
 **/